export interface GetNavItemsParams {
  pageSize: number;
  totalResults: number;
  currentPage?: number;
}

export interface GetNavItemsResult {
  pageNumbers: PageNumbers;
  leftStepper: boolean;
  rightStepper: boolean;
}

export type PageNumbers = (number | PageGap)[];

export const PAGE_GAP = Symbol('PAGE_GAP');
export type PageGap = typeof PAGE_GAP;

export function getNavItems({
  totalResults,
  pageSize,
  ...props
}: GetNavItemsParams): GetNavItemsResult {
  let { currentPage } = props;

  if (totalResults === 0 || pageSize === 0) {
    return {
      pageNumbers: [],
      leftStepper: false,
      rightStepper: false,
    };
  }

  if (!currentPage || currentPage < 1) {
    currentPage = 1;
  }

  const lastPage = Math.ceil(totalResults / pageSize);

  if (currentPage > lastPage) {
    currentPage = lastPage;
  }

  let pageNumbers: PageNumbers;
  if (lastPage <= 5) {
    pageNumbers = Array(lastPage)
      .fill(null)
      .map((_, i) => i + 1);
  } else if (currentPage <= 2) {
    pageNumbers = [1, 2, 3, PAGE_GAP, lastPage];
  } else if (currentPage === 3) {
    pageNumbers = [1, 2, 3, 4, PAGE_GAP, lastPage];
  } else if (currentPage >= lastPage - 1) {
    pageNumbers = [1, PAGE_GAP, lastPage - 2, lastPage - 1, lastPage];
  } else if (currentPage === lastPage - 2) {
    pageNumbers = [1, PAGE_GAP, lastPage - 3, lastPage - 2, lastPage - 1, lastPage];
  } else {
    pageNumbers = [1, PAGE_GAP, currentPage - 1, currentPage, currentPage + 1, PAGE_GAP, lastPage];
  }

  return {
    pageNumbers,
    leftStepper: currentPage > 1,
    rightStepper: currentPage < lastPage,
  };
}
